/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Err_Scenting_DateInputs */

const vi_scl_new_err_scenting_date = /** @type {(inputs: Scl_New_Err_Scenting_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn ngày lấy hương`)
};

/**

* @param {Scl_New_Err_Scenting_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_err_scenting_date = /** @type {((inputs?: Scl_New_Err_Scenting_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Err_Scenting_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_err_scenting_date(inputs)
});